import { Avatar as MUIAvatar } from "@mui/material";
import { getInitials } from "../library/utils";

export default function NGUser({ Users }) {
  const users = Users.value;
  const userAvatars = users
    ? users.map((user, index) => {
        const isActive = user.IsActive;

        const style = {
          display: "flex",
          marginRight: "5px",
          backgroundColor: user.Color,
          border: `4px solid ${isActive ? "#32CD32" : "transparent"}`,
        };

        return (
          <MUIAvatar
            key={`NGUser-avatar-${index}`}
            style={style}
            data-type="user-avatar"
            {...(isActive ? { "data-active": "" } : {})}
          >
            {getInitials(user.Name)}
          </MUIAvatar>
        );
      })
    : null;
  return <div style={{ display: "flex" }}>{userAvatars}</div>;
}
